import * as React from "react";
import { SVGProps } from "react";
export const CloudArrowDownFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5.43801 16.667C4.16001 16.667 3.07301 16.219 2.17701 15.323C1.28101 14.427 0.833008 13.34 0.833008 12.062C0.833008 10.9793 1.15601 10.0247 1.80201 9.198C2.44801 8.37133 3.29867 7.833 4.35401 7.583C4.67334 6.45833 5.26701 5.51733 6.13501 4.76C7.00367 4.00333 8.00034 3.54866 9.12501 3.396V10L8.45801 9.333C8.29134 9.16633 8.09001 9.083 7.85401 9.083C7.61801 9.083 7.41667 9.16633 7.25001 9.333C7.08334 9.49966 7.00001 9.70466 7.00001 9.948C7.00001 10.1907 7.08334 10.3953 7.25001 10.562L9.37501 12.708C9.54167 12.8747 9.75001 12.958 10 12.958C10.25 12.958 10.4583 12.8747 10.625 12.708L12.771 10.562C12.9377 10.3953 13.021 10.1907 13.021 9.948C13.021 9.70466 12.9377 9.49966 12.771 9.333C12.6043 9.16633 12.3993 9.083 12.156 9.083C11.9133 9.083 11.7087 9.16633 11.542 9.333L10.875 10V3.396C12.2777 3.604 13.4617 4.23933 14.427 5.302C15.3923 6.36466 15.875 7.625 15.875 9.083C16.8197 9.19433 17.6043 9.61466 18.229 10.344C18.8543 11.0733 19.167 11.917 19.167 12.875C19.167 13.917 18.7953 14.8093 18.052 15.552C17.3093 16.2953 16.417 16.667 15.375 16.667H5.43801Z"
            fill="currentColor"
        />
    </svg>
);
CloudArrowDownFillIcon.displayName = "CloudArrowDownFillIcon";
